import IconButton from '@material-ui/core/IconButton'

import ArrowDropDownOutlinedIcon from '@material-ui/icons/ArrowDropDownOutlined'
import React from 'react'

interface subHeaderProps {
  title?: any
  rightText?: any
  infoLine?: any
  dropDownOptions?: any
  handleClick?: any
  infoLine2?: any
  infoLine1Style?: any
  infoLine2Style?: any
  // fixResponsive?: boolean //new changes 5/6/2021 by syafiq ali
  isPicture?: any //new changes 5/6/2021 by syafiq ali
}
const DynamicSubHeader2RowInfo = ({
  infoLine,
  rightText,
  title,
  dropDownOptions,
  handleClick,
  infoLine2,
  infoLine1Style,
  infoLine2Style,
  // fixResponsive, //new changes 5/6/2021 by syafiq ali
  isPicture,
}: subHeaderProps) => {
  return (
    //new changes 5/6/2021 by syafiq ali
    <div className={`fix-subheader`}>
      {/* //new changes 5/6/2021 by syafiq ali */}
      <div
        className={`dynamic-subheader-2row fix-subheader-content 
         ${infoLine ? 'multiple' : 'single'} `}
      >
        {isPicture} {/* //new changes 5/6/2021 by syafiq ali */}
        <div className={`${isPicture && 'wraps-dynamic-content'}`}>
          <div className="dynamic-content" onClick={handleClick}>
            <div className="session">
              <div className="title flex-space">{title}</div>
              {rightText && <div className="rightText">{rightText}</div>}
              {dropDownOptions ? (
                <IconButton className="right-btn">
                  <ArrowDropDownOutlinedIcon />
                </IconButton>
              ) : null}
            </div>
          </div>
          <div className="infoline-content">
            <div className="infoline" style={infoLine1Style}>
              {infoLine}
            </div>
          </div>
          <div className="infoline-content">
            <div className="infoline" style={infoLine2Style}>
              {infoLine2}
            </div>
          </div>
        </div>
        {dropDownOptions}
      </div>
    </div>
  )
}

export default DynamicSubHeader2RowInfo
